module.exports = __webpack_public_path__ + "static/img/7-z1.08b5807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/7-z1.png
// module id = 673
// module chunks = 140